













import { Component, Vue } from "vue-property-decorator";
import { syncApi } from "../../services/api/sync.api";
import { State, Action } from "vuex-class";
import QrcodeVue from "qrcode.vue";
import appSnackbarService from "@/services/appSnackbar.service";
import GlobalMixins from "@/global.mixin.ts";

@Component({
  mixins: [GlobalMixins],
  components: { QrcodeVue }
})
export default class MobileSyncView extends Vue {

  @State("inventory") inventoryState: any;

  @Action("inventoryIsAnyOpen") inventoryIsAnyOpen: any;
  @Action("configLoad") configLoad: any;
  @Action("configSave") configSave: any;

  serverRunning = false;
  loading = true;

  qrcode = "Scan this URL";
  qrsize = 400;

  created() {
    this.loading = true;
    // TODO: save the data to the store..when starting server!!!!
    this.inventoryIsAnyOpen();

    syncApi.getIp()
    .then( res => {
      // console.log("url: ", res);
      this.setQrCode(res.data.url);
      this.loading = false;
      this.serverRunning = true;
    })
    .catch( err => {
      // console.log("url: ", err);
      appSnackbarService.error(err);
      this.loading = false;
      this.serverRunning = false;
    });
  }

  setQrCode(url) {
    const qlmUrl = {qlm_api_url: url};
    this.qrcode = JSON.stringify(qlmUrl);
    // appSnackbarService.success("qrcode: ", this.qrcode);
  }

}
